import { Helmet } from "react-helmet"
import {
    Box,
    Button,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    InputAdornment,
    MenuItem,
    OutlinedInput,
    Paper,
    Popover,
    Select,
    TextField,
    Typography
} from "@mui/material"
import React, { useEffect, useCallback } from "react"
import { useNavigate, useLocation, Outlet } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@mui/styles"
import Search from "@mui/icons-material/Search";
import cssVariables from "../theme/cssVariables"
import { find } from "lodash";

import { ReactComponent as FilterIcon } from "../icons/filter.svg"
import { ReactComponent as ArrowRightIcon } from "../assets/icons/arrow-right.svg"
import CustomCheckbox from "../components/CustomCheckbox"

import { getFiltersList } from "../actions/managerDashboard"
import { currentEmployees } from "../actions/admin"

const useStyles = makeStyles({
})

const ManagerDashboardBase = () => {
    const { t, i18n } = useTranslation()
    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const managerDashboardState = useSelector((state) => state.ManagerDashboard)

    const [pathName, setPathName] = React.useState("")
    const filterCode = {
        goal: "dashboard_goal",
        competency: "dashboard_competency",
        achievement: "dashboard_achievement",
        evaluation: "dashboard_evaluation",
    }
    // const filterCode = {
    //     goal: "manager_evaluation",
    //     competency: "manager_evaluation",
    //     achievement: "manager_evaluation",
    //     evaluation: "manager_evaluation",
    // }
    const [currentCycle, setCurrentCycle] = React.useState("")
    const [currentFiltersCode, setCurrentFiltersCode] = React.useState("")
    const [cycleList, setCycleList] = React.useState([])
    const [filtersCheckbox, setFiltersCheckbox] = React.useState([])
    const [filtersCheckboxList, setFiltersCheckboxList] = React.useState([])
    const [masterFiltersCheckboxList, setMasterFiltersCheckboxList] = React.useState([])
    const [filtersQuery, setFiltersQuery] = React.useState("")
    const [checkboxFiltersStatus, setCheckboxFiltersStatus] = React.useState("all")
    const [filterAnchor, setFilterAnchor] = React.useState(null)
    const [searchFilters, setSearchFilters] = React.useState("")
    const [firstVisit, setFirstVisit] = React.useState(true)
    const openFilters = Boolean(filterAnchor)
    const idFilters = openFilters ? 'filters-popover' : undefined

    const handleChangeCycle = (val) => {
        setCurrentCycle(val)
    }

    const handleClickFilters = (event) => {
        setFilterAnchor(event.currentTarget)
    }

    const handleCloseFilters = () => {
        setFilterAnchor(null)
    }

    const handleFiltersCheckbox = (data) => {
        let tmpFiltersCheckbox = JSON.parse(JSON.stringify(filtersCheckbox))
        let tmpFiltersCheckboxList = [...filtersCheckboxList]
        if (data === "all") {
            if (checkboxFiltersStatus === "indeterminate" || checkboxFiltersStatus === "none") {
                let selectAllFilters = tmpFiltersCheckboxList.map(filter => filter.serial)
                tmpFiltersCheckbox = selectAllFilters
            } else if (checkboxFiltersStatus === "all") {
                tmpFiltersCheckbox = []
            }
        } else {
            let isExisted = tmpFiltersCheckbox.find(item => item === data)
            if (isExisted) {
                tmpFiltersCheckbox = tmpFiltersCheckbox.filter(item => item !== data)
            } else if (!isExisted) {
                tmpFiltersCheckbox.push(data)
            }
        }
        setFiltersCheckbox(tmpFiltersCheckbox)
    }

    const checkfiltersCheckboxStatus = () => {
        let result = "none"
        if (filtersCheckbox.length === filtersCheckboxList.length) {
            result = "all"
        } else if (filtersCheckbox.length > 0 && filtersCheckbox.length < filtersCheckboxList.length) {
            result = "indeterminate"
        }
        setCheckboxFiltersStatus(result)
    }

    const handleSearchFilters = (e) => {
        setSearchFilters(e.target.value)
    }

    const fetchAndinitData = () => {
        dispatch(getFiltersList(filterCode[pathName])).then((resp) => {
            if (resp?.cycle) {
                setCycleList(resp.cycle)
                let isDefault = resp?.cycle.find((obj) => obj.is_current)
                let currentCycle = null
                if (isDefault) {
                    currentCycle = isDefault
                } else {
                    currentCycle = resp?.cycle?.length > 0 ? resp.cycle?.[0] : ""
                }
                if (firstVisit) setCurrentCycle(currentCycle?.serial ?? "")

                // first org filters
                if (currentCycle) {
                    let organizationFilters = currentCycle?.options?.organizations
                    if (organizationFilters) {
                        setFiltersCheckboxList(organizationFilters)
                        setMasterFiltersCheckboxList(organizationFilters)
                        // check all default
                        if (firstVisit) {
                            let checkedAll = organizationFilters.map(filter => filter.serial)
                            setFiltersCheckbox(checkedAll)
                        }
                    }
                }
            }
        })
        setFirstVisit(false)
    }

    // ****useEffect****
    // fetch & init data
    useEffect(() => {
        if (pathName !== "") fetchAndinitData()
        setCurrentFiltersCode(filterCode[pathName])
    }, [pathName])
    useEffect(() => {
        let getCycleData = cycleList.find(cycle => cycle.serial === currentCycle)
        dispatch({
            type: "SET_CYCLE_DASHBOARD_MANAGER",
            payload: getCycleData
        })
        // when cycle change, do updated organization filters
        if (currentCycle && currentCycle !== "") {
            let cycleData = cycleList.find(cycle => cycle.serial === currentCycle)
            let organizationFilters = cycleData?.options?.organizations
            if (organizationFilters) {
                setFiltersCheckboxList(organizationFilters)
                setMasterFiltersCheckboxList(organizationFilters)
                // do check 
                let checkedAll = filtersCheckbox.map(filter => {
                    let find = organizationFilters.find(item => filtersCheckbox.includes(item.serial))
                    if (find) {
                        return filter
                    }
                })
                setFiltersCheckbox(checkedAll)
            }
        }
    }, [currentCycle])
    useEffect(() => {
        let locationPathName = location?.pathname?.split("/") ?? []
        locationPathName = locationPathName?.filter(path => path !== "" && path !== "kpi" && path !== "dashboard").pop()
        setPathName(locationPathName)
        dispatch({
            type: "SET_PATHNAME_DASHBOARD_MANAGER",
            payload: locationPathName
        })
    }, [location.pathname])
    // select all status
    useEffect(() => {
        checkfiltersCheckboxStatus()
        dispatch({
            type: "SET_FILTERS_DASHBOARD_MANAGER",
            payload: filtersCheckbox
        })
    }, [filtersCheckbox])

    useEffect(() => {
        let query = []
        if (filtersCheckbox && currentCycle) {
            let tmpQuery = filtersCheckbox?.map(filter => {
                return `${filter}`
            })

            let listOrgId = []
            for (const serial of tmpQuery) {
                let org = find(filtersCheckboxList, { serial: serial })
                if (org) listOrgId.push(org.id)
            }

            tmpQuery = listOrgId.join(",")
            tmpQuery = `organization_id=${tmpQuery}`
            query.push(tmpQuery)
            query.push(`cycle_id=${currentCycle}`)
            query = query.join("&")
            setFiltersQuery(query)
        }
    }, [filtersCheckbox, currentCycle])

    // search
    useEffect(() => {
        let resultList = JSON.parse(JSON.stringify(masterFiltersCheckboxList))
        if (searchFilters !== "") {
            resultList = resultList.filter(filter => filter?.name?.toLowerCase()?.includes(searchFilters?.toLowerCase()))
        }
        setFiltersCheckboxList(resultList)
    }, [searchFilters])
    // ****end useEffect****

    return (
        <>
            <Helmet>
                <title>Dashboard | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "background.default",
                    minHeight: "100%",
                    py: 3,
                }}
            >
                <Container maxWidth="xl">
                    <Grid container mt={1} mb={1}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={{ color: "#5DA196", cursor: "pointer", }} onClick={() => navigate(`/kpi/home`)}>{t('label.home')}</span>
                            {` / `}
                            <span style={{ color: "#A3A3A3" }} >{t(`label.${pathName && pathName?.length > 0 ? pathName : "-"}`)}</span>
                        </Typography>
                    </Grid>
                    <Grid container spacing={2} mt={1} mb={2}>
                        <Grid item display="flex" flexDirection="column" justifyContent="space-between">
                            <Grid container item>
                                <Typography fontSize={36} lineHeight="39.6px" fontWeight="600" color="#404349">
                                    {t(`label.${pathName && pathName?.length > 0 ? pathName : "-"}`)}
                                </Typography>
                            </Grid>
                            <Grid container>
                                <Grid item mr={4}>
                                    <FormControl fullWidth>
                                        <Select
                                            displayEmpty
                                            id="cycle-select-form"
                                            value={currentCycle}
                                            onChange={(val) => { handleChangeCycle(val.target.value) }}
                                            input={<OutlinedInput size="small" />}
                                            sx={
                                                {
                                                    width: "400px",
                                                    height: "45px"
                                                }
                                            }
                                        >
                                            {cycleList.map((option, idx) => {
                                                return <MenuItem key={idx} value={option.serial}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option.name}</Typography></MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size="small"
                                        aria-controls="filters-menu"
                                        aria-haspopup="true"
                                        onClick={handleClickFilters}
                                        color="black"
                                        variant="outlined"
                                        sx={{
                                            marginRight: '15px',
                                            textTransform: "none",
                                            height: "45px",
                                            minWidth: "143px",
                                            ...(filtersCheckbox.length > 0 && {
                                                border: "1px solid #5DA196",
                                                background: "#EFF6F4"
                                            })
                                        }}
                                    >
                                        <FilterIcon style={{ width: '20px', height: '20px' }} />
                                        <Typography ml={1} fontWeight="600" fontSize="16px">{t("dashboardManager.label.filters")}</Typography>
                                        {
                                            filtersCheckbox.length > 0 &&
                                            <Box sx={{ ml: 1, borderRadius: "50%", background: "#5DA196", color: "#FFF", width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <Typography fontWeight="500" fontSize="18px">{filtersCheckbox.length}</Typography>
                                            </Box>
                                        }
                                    </Button>
                                    <Popover
                                        id={idFilters}
                                        open={openFilters}
                                        anchorEl={filterAnchor}
                                        onClose={handleCloseFilters}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        {filtersCheckboxList ?
                                            (<Box
                                                sx={{
                                                    p: 2,
                                                }}>
                                                <Typography fontSize="16px" fontWeight="600" sx={{ my: 1 }}>
                                                    {t("label.organization")}
                                                </Typography>
                                                <TextField
                                                    id="search-filters"
                                                    fullWidth
                                                    placeholder={t("dashboardManager.label.searchPlaceholder")}
                                                    size="small"
                                                    sx={{
                                                        background: "#fff",
                                                        width: "100%",
                                                        input: { padding: "12px 14px", height: "10px" },
                                                        mb: 1
                                                    }}
                                                    className="searchTextField-h40"
                                                    value={searchFilters}
                                                    onChange={handleSearchFilters}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Search style={{ color: "#C4C4C4" }} />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        flexDirection: "column",
                                                        pl: "4px",
                                                        pr: "4px"
                                                    }}>
                                                    <FormControlLabel
                                                        style={{ fontSize: '14px' }}
                                                        label={t("label.selectAll")}
                                                        control={
                                                            <CustomCheckbox
                                                                checked={checkboxFiltersStatus === 'all'}
                                                                indeterminate={checkboxFiltersStatus === 'indeterminate'}
                                                                onChange={() => handleFiltersCheckbox("all")}
                                                            />
                                                        }
                                                    />
                                                    {
                                                        filtersCheckboxList.map((item) => {
                                                            return (
                                                                <FormControlLabel
                                                                    style={{ fontSize: '14px' }}
                                                                    label={item?.name ?? (i18n.language === "en-US" ? item?.name_en ?? "" : item?.name_th ?? "")}
                                                                    key={item?.serial}
                                                                    control={<CustomCheckbox color="primary" checked={filtersCheckbox.includes(item?.serial)} onChange={() => handleFiltersCheckbox(item?.serial)} />}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Box>
                                            </Box>) : null
                                        }
                                    </Popover>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item ml="auto">
                            <Paper sx={{ width: "250px", height: "100px", borderRadius: "5px", p: "12px 20px", display: "flex", justifyContent: "center" }}>
                                <Grid container>
                                    <Grid item display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <Grid container>
                                            <Grid item>
                                                <Typography fontSize="36px" fontWeight="600" color="#5DA196">{managerDashboardState?.totalEmployee}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item>
                                                <Typography fontSize="14px" fontWeight="400" color="#6B6B6B">{t("dashboardManager.label.totalEmployee")}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item display="flex" alignItems="center" justifyContent="center" ml="auto">
                                        <Box sx={{ background: "rgba(93, 161, 150, 0.1)", borderRadius: "50%", width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", "&:hover": { cursor: "pointer" } }} onClick={() => window.open(`/kpi/employee-list?filter=${currentFiltersCode}&${filtersQuery}`, '_blank')}>
                                            <ArrowRightIcon />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Outlet context={[currentFiltersCode]} />
                </Container>
            </Box>
        </>
    );
};
export default ManagerDashboardBase;
